export type HypersceneIfcMergeMatrix = number[];

export interface HypersceneIfcMergeItem {
  file: File;
  matrix: HypersceneIfcMergeMatrix;
}

export const defaultHypersceneIfcMergeMatrix = (): HypersceneIfcMergeMatrix => [
  1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1,
];
